import { render } from "./ShieldsDetails.vue?vue&type=template&id=78a568c7&lang=html"
import script from "./ShieldsDetails.vue?vue&type=script&lang=js"
export * from "./ShieldsDetails.vue?vue&type=script&lang=js"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__